import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Droplets } from 'lucide-react';
import { useAuthStore } from '../store';

export function Login() {
  const navigate = useNavigate();
  const { setUser, setToken } = useAuthStore();

  const handleEnter = () => {
    setUser({
      id: '1',
      email: 'jdurand@jrdcompanies.com',
      companyName: 'Maplewood Auto Service',
      role: 'owner',
      subscriptionTier: 'professional',
      createdAt: new Date(),
    });
    setToken('sample-token');
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-bg-darker flex items-center justify-center p-4">
      {/* Noise overlay */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none bg-noise" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        {/* Logo */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-6"
        >
          <img
            src="/maplewood-auto-logo.png"
            alt="Maplewood Auto Service"
            className="w-48 h-48 mx-auto object-contain"
          />
        </motion.div>

        {/* Title */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="mb-8"
        >
          <div className="flex items-center justify-center gap-2 mb-2">
            <Droplets className="w-6 h-6 text-jrd-orange" />
            <h1 className="text-2xl font-bold text-text-primary tracking-tight">
              UNLIMITED WASH
            </h1>
            <Droplets className="w-6 h-6 text-jrd-orange" />
          </div>
          <p className="text-text-muted text-sm font-mono">
            featuring <span className="text-jrd-green">Maplewood Auto Service</span>
          </p>
        </motion.div>

        {/* Sample Data Card */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="bg-bg-card border border-text-muted/20 rounded-lg p-6 mb-6"
        >
          {/* Sample data badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-jrd-green/10 border border-jrd-green/30 rounded-full mb-4">
            <div className="w-2 h-2 rounded-full bg-jrd-green animate-pulse" />
            <span className="text-jrd-green text-xs font-mono uppercase tracking-wider">
              Sample Data
            </span>
          </div>

          <p className="text-text-secondary text-sm mb-6">
            Demo mode with sample data loaded. Click below to explore the app.
          </p>

          <button
            onClick={handleEnter}
            className="w-full btn-primary flex items-center justify-center gap-3 py-3 text-lg"
          >
            <span>Next</span>
            <ArrowRight className="w-5 h-5" />
          </button>
        </motion.div>

        {/* Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="text-text-muted text-xs font-mono"
        >
          // powered by XpresWash + JRD Companies
        </motion.div>
      </motion.div>
    </div>
  );
}
